var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsnurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-shield-100784 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1461 10.4208C16.1461 11.1952 15.7861 12.0224 15.0841 12.9024C14.4721 13.6768 13.5901 14.4688 12.4741 15.2608C11.0881 16.2464 9.68406 16.968 8.98206 17.3024C8.29806 16.968 6.87606 16.2464 5.49006 15.2608C4.37406 14.4688 3.51006 13.6768 2.88006 12.9024C2.17806 12.0224 1.83606 11.1952 1.83606 10.4208V0.300781H8.98206H16.1281L16.1461 10.4208ZM12.7261 6.67198H9.77406V3.78558H8.22606V6.67198H5.27406V8.18558H8.22606V11.072H9.77406V8.18558H12.7261V6.67198Z",
    fill: "#5571C6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsnurance);
export default __webpack_public_path__ + "static/media/isnurance.12d83126bda9e8fb6f6f448fa8bd1c51.svg";
export { ForwardRef as ReactComponent };